module.exports = __webpack_public_path__ + "img/bh_7.e03347da.jpg";